var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRemove(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 14,
    viewBox: "0 0 12 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9999 2.33333H8.99988V1.16667C8.99988 0.857247 8.87345 0.560501 8.64841 0.341709C8.42336 0.122916 8.11814 0 7.79988 0L4.19988 0C3.88162 0 3.57639 0.122916 3.35135 0.341709C3.12631 0.560501 2.99988 0.857247 2.99988 1.16667V2.33333H-0.00012207V3.5H1.19988V12.25C1.19988 12.7141 1.38952 13.1592 1.72709 13.4874C2.06465 13.8156 2.52249 14 2.99988 14H8.99988C9.47727 14 9.93511 13.8156 10.2727 13.4874C10.6102 13.1592 10.7999 12.7141 10.7999 12.25V3.5H11.9999V2.33333ZM4.19988 1.16667H7.79988V2.33333H4.19988V1.16667ZM9.59988 12.25C9.59988 12.4047 9.53666 12.5531 9.42414 12.6625C9.31162 12.7719 9.15901 12.8333 8.99988 12.8333H2.99988C2.84075 12.8333 2.68814 12.7719 2.57561 12.6625C2.46309 12.5531 2.39988 12.4047 2.39988 12.25V3.5H9.59988V12.25Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemove);
export default __webpack_public_path__ + "static/media/Remove.a4885f4ef85dabaa8561c905d33e5580.svg";
export { ForwardRef as ReactComponent };